import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { API_PATH } from '@app/app.constants';
import {
    ResponseBaseCards,
    ResponseSimpleCards,
    ResponseNamedCards,
    ResponseCertificates,
    ResponseAwards,
    ResponseAward,
    ResponseMain,
    ResponseAwardEvents
} from '@app/_interfaces/responses';

export class AchievementsService {
    constructor(private api: APIService) {}

    getAwardEvents(): Observable<ResponseAwardEvents> {
        return this.api.get(API_PATH.achievements.award_events);
    }

    getSimpleCards(): Observable<ResponseSimpleCards> {
        return this.api.get(API_PATH.achievements.standart_cards);
    }

    getNamedCards(): Observable<ResponseNamedCards> {
        return this.api.get(API_PATH.achievements.named_cards);
    }

    getCertificates(): Observable<ResponseCertificates> {
        return this.api.get(API_PATH.achievements.certificates);
    }

    getAwards(): Observable<ResponseAwards> {
        return this.api.get(API_PATH.achievements.awards);
    }

    getAward(awardId: number): Observable<ResponseAward> {
        const url = `${API_PATH.achievements.user_awards}${awardId}`;
        return this.api.get(url);
    }

    addStudentsAwards(data: any): Observable<ResponseMain> {
        return this.api.post(API_PATH.achievements.add_students_awards, data);
    }

    updateStudentsAwards(awardId: number, data: any): Observable<ResponseMain> {
        const url = `${API_PATH.achievements.user_awards}${awardId}`;
        return this.api.post(url, data);
    }

    getUserAwards(userId: number): Observable<ResponseAwards> {
        const url = `${API_PATH.achievements.user_awards}/user/${userId}`;
        return this.api.get(url);
    }

    getEventAwardCards(ev: number): Observable<ResponseBaseCards> {
        const url = `${API_PATH.achievements.event_award_cards}${ev}/`;
        return this.api.get(url);
    }

    getDuplicateCardAwards(userId: number, cardType: string, cardId: number): Observable<ResponseAwards> {
        const url = `${API_PATH.achievements.duplicate_card_awards}/${userId}/${cardType}/${cardId}`;
        return this.api.get(url);
    }

    updateUsedPrivileges(userId: number, characters: Array<number>): Observable<ResponseMain> {
        const url = `${API_PATH.achievements.update_used_privileges}`;
        const data = {
            user_id: userId,
            characters: characters
        };

        return this.api.post(url, data);
    }

    deleteAward(awardId: number): Observable<ResponseMain> {
        const url = `${API_PATH.achievements.user_awards}${awardId}`;
        return this.api.delete(url);
    }
}
